import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import {
  DatastoreContestQuickviewEntriesModule,
  DatastoreContestRubricSubmissionsModule,
  DatastoreContestViewEntriesModule,
  DatastoreUsersModule,
} from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { QuickviewModalSharedModule } from 'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/quickview-modal-shared.module';
import { JudgeScoringModalComponent } from './judge-scoring-modal.component';
import { JudgeEntryFileViewerComponent } from '../judge-entry-file-viewer/judge-entry-file-viewer.component';
import { JudgeScorecardSectionComponent } from '../judge-scorecard/judge-scorecard-section.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    JudgeEntryFileViewerComponent,
    JudgeScorecardSectionComponent,
    DatastoreContestQuickviewEntriesModule,
    DatastoreContestRubricSubmissionsModule,
    DatastoreContestViewEntriesModule,
    DatastoreUsersModule,
    QuickviewModalSharedModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [JudgeScoringModalComponent],
})
export class JudgeScoringModalModule {}
